import { Reducer, combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import commonSlice from './features/common.slice';
import trackingPageMediaSlice from '@/redux/features/trackingPageMedia.slice';
import { apiCaller } from './api/api.caller';
import authSlice from './features/auth.slice';
import contextualBarSlice from './features/contextualBar.slice';
import dashboardPageSlice from './features/dashboard.slice';
import dashboardSessionSlice from './features/dashboardSession.slice';
import emailSlice from './features/email.slice';
import { notificationsSlice } from './features/notifications.slice';
import planSlice from './features/plan.slice';
import reviewTableSlice from './features/reviewTable.slice';
import settingsSlice from './features/settings.slice';
import shipmentSlice from './features/shipment.slice';
import smsSlice from './features/sms.slice';
import trackingLogsSlice from './features/trackingLogs.slice';
import trackingPageSlice from './features/trackingPage.slice';
import languagesReducer from './features/languages.slice';
import welcomeReducer from './features/welcome.slice';
import onboardingGuideReducer from './features/onboardingGuide.slice';
import aiPromoSlice from './features/aiPromo.slice';
import {
  authPersistConfig,
  commonPersistConfig,
  dashboardPersistConfig,
  dashboardSessionPersistConfig,
  emailPersistConfig,
  notificationsPersistConfig,
  planPersistConfig,
  sessionPersistConfig,
  settingsPersistConfig,
  shipmentPersistConfig,
  smsPersistConfig,
  trackingPagePersistConfig,
  welcomePersistConfig,
  onboardingGuidePersistConfig,
  aiPromoPersistConfig,
} from './persist.config';
import { sessionSlice } from '@/redux/features/session.slice';
import { cmsApiCaller } from './api/cms.caller';

const rtkQueryMiddleware = [apiCaller.middleware, cmsApiCaller.middleware];

const rootReducer = combineReducers({
  // Thêm Reducer tại đây. Sample : sample : sampleReducer
  common: persistReducer(commonPersistConfig, commonSlice.reducer),
  dashboard: persistReducer(dashboardPersistConfig, dashboardPageSlice.reducer),
  dashboardSession: persistReducer(dashboardSessionPersistConfig, dashboardSessionSlice.reducer),
  reviewTable: reviewTableSlice.reducer,
  shipment: persistReducer(shipmentPersistConfig, shipmentSlice.reducer),
  trackingPage: persistReducer(trackingPagePersistConfig, trackingPageSlice.reducer),
  trackingLogs: trackingLogsSlice.reducer,
  plan: persistReducer(planPersistConfig, planSlice.reducer),
  email: persistReducer(emailPersistConfig, emailSlice.reducer),
  sms: persistReducer(smsPersistConfig, smsSlice.reducer),
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  settings: persistReducer(settingsPersistConfig, settingsSlice.reducer),
  notifications: persistReducer(notificationsPersistConfig, notificationsSlice.reducer),
  apiCaller: apiCaller.reducer,
  cmsApiCaller: cmsApiCaller.reducer,
  trackingPageMedia: trackingPageMediaSlice.reducer,
  contextualBar: contextualBarSlice.reducer,
  languages: languagesReducer,
  session: persistReducer(sessionPersistConfig, sessionSlice.reducer),
  welcome: persistReducer(welcomePersistConfig, welcomeReducer),
  onboardingGuide: persistReducer(onboardingGuidePersistConfig, onboardingGuideReducer),
  aiPromo: persistReducer(aiPromoPersistConfig, aiPromoSlice.reducer),
});

const store = configureStore({
  reducer: rootReducer as Reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(rtkQueryMiddleware),
});

// setupListeners(store.dispatch)
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
export default store;
